import { FreeplayEvent, FreeplayLeague } from "@freeplay/shared-code";
import { format } from "date-fns";
import React from "react";
import { View } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { FadeInFromColour } from "../components/animations/FadeInFromColour";
import { MediaQueries } from "../components/hooks/dynamicStyleHook";
import { GlobalStyles } from "../components/style/Style";
import { GameButton } from "../components/textcontainers/home/GameButton";
import { useServices } from "../contexts/ServiceContext";
import DefaultImage from "../assets/default_background.png";
import DefaultTSImage from "../assets/default_background_ts.png";

interface HomeProps {
    handleEvent: (event: FreeplayEvent) => void;
    animationComplete: () => void;
    useFadeIn: boolean;
    currentEvents: FreeplayEvent[];
}

// imageUri="https://extrabetamerica.imgix.net/b56504f73d9e478db0d6ed6b804de2ea.jpg?fit=crop&crop=focalpoint&fp-x=.65&fp-y=.35&&fp-z=1.5&w=300&ar=2:1"
// imageUri="https://extrabetamerica.imgix.net/33a4c51903c6441eadd7ca83c5632c69.jpg?fit=crop&crop=faces&w=300&ar=2:1"
// imageUri="https://extrabetamerica.imgix.net/f161754469334b63b01a511d579806cd.jpg?fit=crop&crop=faces&w=300&ar=2:1"
// imageUri="https://extrabetamerica.imgix.net/74e018a2a7c946a592fc1f7bac5317aa.jpg?fit=crop&crop=faces&w=300&ar=2:1"
// imageUri="https://extrabetamerica.imgix.net/d181031eddca4e34a3d50147841ef74a.jpg?fit=crop&crop=faces&w=300&ar=2:1"
// imageUri="https://extrabetamerica.imgix.net/c9ef987f3955498ab13c24eb2bc05b25.jpg?fit=crop&crop=faces&w=300&ar=2:1"

export const HomeView: React.FC<HomeProps> = ({ animationComplete, currentEvents, handleEvent, useFadeIn }) => {
    const { edgeDeploy } = useServices();
    const styles = useDynamicStyles(generateStyles);

    return (
        <View style={[edgeDeploy ? styles.edgeContainer : styles.container]}>
            {useFadeIn && (
                <FadeInFromColour
                    backgroundColour={EStyleSheet.value(GlobalStyles.BASE_COLOUR)}
                    duration={500}
                    toValue={0}
                    onComplete={animationComplete}
                />
            )}
            {currentEvents.map((event, index) => {
                return (
                    <GameButton
                        key={`game_button_${event.id}`}
                        imageUri={event.game.league === FreeplayLeague.Other ? DefaultTSImage : DefaultImage}
                        title={event.name}
                        timeLine={format(new Date(event.bettingEnds), "LLLL d, h:mm b")}
                        prizeString={event.prizeLabel}
                        ctaLabel={"Play Now"}
                        last={index === currentEvents.length - 1}
                        onPress={() => handleEvent(event)}
                    />
                );
            })}
        </View>
    );
};
export default HomeView;

const generateStyles = () => {
    return EStyleSheet.create({
        [MediaQueries.XLARGE]: {
            edgeContainer: {
                marginVertical: 0,
                borderRadius: 0,
            },
        },
        [MediaQueries.MEDIUM]: {
            edgeContainer: {
                padding: 7.5,
            },
        },
        edgeContainer: {
            flex: 1,
            flexWrap: "wrap",
            flexDirection: "row",
            padding: 15,
            marginVertical: 30,
            overflowY: "auto",
            backgroundColor: () => EStyleSheet.value(GlobalStyles.BACKGROUND_COLOUR),
            borderRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
        },
        container: {
            flex: 1,
            padding: 10,
            paddingTop: 0,
            overflowY: "auto",
        },
    });
};
